// [S-091a] Welcome — post-password-reset landing page.
//
// Identity Platform's hosted reset page handles the password set. After
// the user submits a new password, IP redirects them here via the
// action-code-settings.url configured on FirebaseIdentityProviderAdapter
// (see apps/admin/src/index.ts WEB_WELCOME_URL). This screen is a
// friendly landing that tells them what just happened and routes them
// to /login.
//
// No auth required — the route is reachable both authenticated (rare:
// user manually visits) and anonymous (typical: just came back from
// the reset flow without a session yet). Authenticated users get
// bounced to /home so they don't see a stale "set your password"
// message.
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { Button } from "../components";

export function Welcome(): JSX.Element {
  const { state } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (state.status === "authenticated") {
      navigate("/home", { replace: true });
    }
  }, [state.status, navigate]);

  return (
    <main className="login" data-testid="welcome">
      <div className="login__card">
        <h1 className="login__title">Welcome to ContractStudio</h1>
        <p className="login__sub">
          Your password is set. Sign in with the email your admin invited
          and the password you just chose.
        </p>
        <div style={{ marginTop: 16 }}>
          <Button
            variant="primary"
            onClick={() => navigate("/login", { replace: true })}
            data-testid="welcome-signin"
          >
            Go to sign-in
          </Button>
        </div>
      </div>
    </main>
  );
}
